/**
 * Evita mostrar en UI cadenas que son claves i18n sin resolver (p. ej. plans.free.price).
 * No bloquea textos humanos con espacios, URLs ni importes con símbolos.
 *
 * @param {string} output - Valor ya resuelto (post-interpolación)
 * @param {string} requestedKey - Clave pedida a t()
 * @returns {boolean}
 */
export function shouldBlockI18nStringResult(output, requestedKey) {
  if (typeof output !== 'string' || output === '') {
    return false;
  }
  if (output === requestedKey) {
    return true;
  }
  if (!output.includes('.') || /\s/.test(output)) {
    return false;
  }
  if (/^https?:\/\//i.test(output) || output.includes('://')) {
    return false;
  }
  if (/[$€£¥₹]/.test(output)) {
    return false;
  }
  // Mínimo namespace.segment.leaf (tres segmentos)
  return /^[a-z][a-z0-9_]*(\.[a-z][a-z0-9_]*){2,}$/i.test(output);
}
